module.exports = __webpack_public_path__ + "img/Logo12.9f203412.svg";